export default __webpack_public_path__ + "static/media/Shop1.7a311efb.jpeg";